import React, { useContext, useEffect, useState } from 'react'
import Cards from './Cards'
import General from './Genral'
import Logout from './Logout'
import SiteBlocker from './SiteBlocker'
import OutsetaProfile from './OutsetaProfile'
import { AuthContext } from '../../AuthProvider'
import AiAssistant from './AiAssistant'
import Rituals from './Rituals'
import DataExport from './DataExport'

function Settings() {
  const hash = window.location?.hash ? window.location.hash.replace('#', '') : null;
  const { redirection, setRedirection, userProfile } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(
    hash === 'planChange' || hash === 'planCancel'
      ? 'billing'
      : hash === 'data-export'
        ? 'data-export'
        : hash !== null && hash !== ''
          ? hash
          : '',
  )

  useEffect(() => {
    if(redirection){
      switch(redirection){
        case '/settings':
          setActiveTab('block');
          break;
        default:
          break;
      }
      setRedirection(false);
    }
  }, [redirection])

  return (
    <div className="form-content">
      <div className="setting-form common-form">
        <div className="setting-tabs">
          <ul className="ul-setting-tab">
            <General activeTab={activeTab} setActiveTab={setActiveTab} />
            <DataExport activeTab={activeTab} setActiveTab={setActiveTab} />
            <OutsetaProfile trigger={hash} activeTab={activeTab} setActiveTab={setActiveTab} />
            {userProfile?.NewFeatureTester == 'true' && <Rituals activeTab={activeTab} setActiveTab={setActiveTab} />}
            <Cards activeCard={activeTab?.split(':')?.[1] ?? null} activeTab={activeTab?.split(':')?.[0] ?? ''} setActiveTab={setActiveTab} />
            <AiAssistant activeTab={activeTab} setActiveTab={setActiveTab} />
            <SiteBlocker activeTab={activeTab} setActiveTab={setActiveTab} />
            <Logout activeTab={activeTab} setActiveTab={setActiveTab} />
            
            {/* <PlansAndBilling trigger={hash} activeTab={activeTab} setActiveTab={setActiveTab} /> */}
            {/* <Today  isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
            {/* <Tasks  isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
            {/* <Habits isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
            {/* <Journal isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
            {/* <FocusTimer isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
            {/* <SortCuts isActiveSettings={isActiveSettings} setIsActiveSettings={setIsActiveSettings}/> */}
          </ul>
        </div></div>
    </div>
  )
}

export default Settings